module.exports = __webpack_public_path__ + "img/notice-app.c869990a.svg";